<template lang="pug">
  .pf-slide
    .plate(:style="'background-color:' + color")
      .type(v-text="type")
      .title.text-clip(v-text="name")
      .cost
        .param.hs-text(v-text="staticText.cost")
        .value {{ price|addCurSym }}
      .count
        .param.hs-text(v-text="staticText.count")
        .value(v-text="qty")
      .total
        .param.hs-text(v-text="staticText.totalCost")
        .value {{ money|addCurSym }}
</template>

<script>
import { _cfg } from '@/config'

export default {
  name: 'RiskProfileSummarySlide',

  // Props ---------------------------------------------------------------------
  props: {
    type: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    qty: {
      type: Number,
      default: 0
    },
    price: {
      type: Number,
      default: 0
    },
    money: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: ''
    }
  },

  // Data ----------------------------------------------------------------------
  data () {
    return {

      // Component static text
      staticText: {
        cost: 'Цена:',
        count: 'Количество:',
        totalCost: 'Общая сумма:'
      }
    }
  },

  // Filters -------------------------------------------------------------------
  filters: {

    // Add currency symbol
    addCurSym (value) {
      // If float
      if (Number(value) === value && value % 1 !== 0) return value.toFixed(2) + ' ' + _cfg.common.currency
      return value + ' ' + _cfg.common.currency
    }

  }
}
</script>
